import * as S from "./styles";
import { useDbFunctions, useEvents } from "@/talons";
import { useCallback, useMemo, useState } from "react";
import versionHistory from "@/constants/version-history.json"
import { unregisterServiceWorker } from "@/shared/serviceWorkFunctions";
import ModalVersionHistory from "@/components/modal-version-history/ModalVersionHistory";
import { useAlert, useGlobals, useNetworkStatusContext, useSync, useUserContext } from "@/hooks";

type Props = {
  showInfos?: boolean
}

const InfosVersion = ({ showInfos = true }:Props) => {
  const db = useDbFunctions();
  const { showAlert } = useAlert();
  const { customer } = useUserContext();
  const { registerEvent } = useEvents(db);
  const { syncDatasets, setIsOpenedModal } = useSync();
  const { checkConnectivity } = useNetworkStatusContext();
  const { lastSync, version, lastCheckedVersion, setLastCheckedVersion } = useGlobals();

  const [isOpenModal, setModalState] = useState(false);

  const showDot = useMemo(() => {
    return lastCheckedVersion !== version && version === versionHistory.version
  }, [lastCheckedVersion, version])

  const handleOpenVersionHistoryModal = useCallback(() => {
    setModalState(true)
    setLastCheckedVersion(version)
  }, [setModalState, setLastCheckedVersion, version]);

  const handleSyncDatasets = useCallback(async () => {
    setIsOpenedModal(true);

    const isConnected = await checkConnectivity();
    if (!isConnected) {
      showAlert({
        title: 'Você está offline.',
        message: 'Por favor, verifique sua conexão e tente novamente.',
        theme: 'warning',
        time: 15000,
        bordered: true,
        close: 'icon',
        isList: false,
      });
      setIsOpenedModal(false);
      return;
    }
    
    syncDatasets({ isBackground: false, codPessoa: `${customer?.codPessoa}` })
  }, [syncDatasets])

  return (
    <>
      <S.Container>
        {showInfos && <S.InfosContent>
          <S.MomentContent>
            <S.CalendarScheduleLine size={21} />

            <S.MomentData>
              <S.SyncLabel>Última sincronização</S.SyncLabel>
              <S.LastSync>{lastSync}</S.LastSync>
            </S.MomentData>
          </S.MomentContent>

          <S.Container>
            <S.SyncButton onClick={handleSyncDatasets}>
              <S.SyncButtonIcon size={21} />
              <S.SyncButtonLabel>Sincronizar</S.SyncButtonLabel>
            </S.SyncButton>
          </S.Container>
        </S.InfosContent>}

        <S.VersionContent className="version-content">
          <S.LineVersion>
            <S.Version $redDot={showDot} onClick={async () => {
              registerEvent({
                offline: true,
                tipoEvento: 'SINC_VERSAO',
                obsEvento: `Sincronização de versão ${version} iniciada`,
              });

              const isOnline = await checkConnectivity();
              if (!isOnline) {
                showAlert({
                  title: 'Você está offline.',
                  message: 'Por favor, verifique sua conexão e tente novamente.',
                  theme: 'warning',
                  time: 15000,
                  bordered: true,
                  close: 'icon',
                  topPosition: 75,
                });
                return
              }
              if (version !== versionHistory.version) {
                await unregisterServiceWorker({})
                window.location.reload();
              } else {
                handleOpenVersionHistoryModal();
              }
            }}>Versão {version}</S.Version>
          </S.LineVersion>
        </S.VersionContent>
      </S.Container>

      <ModalVersionHistory isOpenModal={isOpenModal} setModalState={setModalState} />
    </>
  );
};

export default InfosVersion;
